/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInEngagementTrendPoint
 */
export interface DropInEngagementTrendPoint {
    /**
     * Calendar date as YYYYMMDD integer (UTC)
     * @type {number}
     * @memberof DropInEngagementTrendPoint
     */
    date: number;
    /**
     * 
     * @type {number}
     * @memberof DropInEngagementTrendPoint
     */
    impression: number;
    /**
     * 
     * @type {number}
     * @memberof DropInEngagementTrendPoint
     */
    click: number;
    /**
     * 
     * @type {number}
     * @memberof DropInEngagementTrendPoint
     */
    follow: number;
}

/**
 * Check if a given object implements the DropInEngagementTrendPoint interface.
 */
export function instanceOfDropInEngagementTrendPoint(value: object): value is DropInEngagementTrendPoint {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('impression' in value) || value['impression'] === undefined) return false;
    if (!('click' in value) || value['click'] === undefined) return false;
    if (!('follow' in value) || value['follow'] === undefined) return false;
    return true;
}

export function DropInEngagementTrendPointFromJSON(json: any): DropInEngagementTrendPoint {
    return DropInEngagementTrendPointFromJSONTyped(json, false);
}

export function DropInEngagementTrendPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInEngagementTrendPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'impression': json['impression'],
        'click': json['click'],
        'follow': json['follow'],
    };
}

export function DropInEngagementTrendPointToJSON(json: any): DropInEngagementTrendPoint {
    return DropInEngagementTrendPointToJSONTyped(json, false);
}

export function DropInEngagementTrendPointToJSONTyped(value?: DropInEngagementTrendPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'impression': value['impression'],
        'click': value['click'],
        'follow': value['follow'],
    };
}

